import { Chip, Stack, Tooltip } from '@mui/material';
import { exchangeStates, publicationColor, publicationLabel } from '../publicationStatus';

/**
 * Stan giełdowy jako znacznik — wersja z produkcji 0.31.3 (`ExchangeCell`
 * z `cells.tsx` na `main`, skopiowana bez zmian treści). Pokazywana
 * w „Znacznikach”, gdy przełącznik `exchangeColumn` jest wyłączony (wersja
 * „obecna”, decyzja użytkownika 12.10.2026); z przełącznikiem stan ma własną
 * kolumnę „Giełda” (`ExchangeCell`). Po decyzji „wchodzi” — do usunięcia.
 *
 * Chip pokazuje nazwę giełdy razem z nazwą stanu („TIMOCOM: Wystawiona”),
 * a kolor tylko to powtarza. Odnośnik oddaje giełda przy wystawieniu; bez
 * niego chip zostaje zwykłym napisem — nie budujemy adresu z kodu oferty.
 */
export const ExchangeChipsLegacy = ({ record }: { record: Record<string, unknown> }) => {
  const states = exchangeStates(record);
  if (states.length === 0) return <span>—</span>;
  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap' }}>
      {states.map((s) => {
        const chip = (
          <Chip
            size="small"
            variant="outlined"
            color={publicationColor(s.status)}
            label={publicationLabel(s)}
          />
        );
        return s.link ? (
          <Tooltip key={s.exchange} title="Otwórz ofertę na giełdzie">
            <a href={s.link} target="_blank" rel="noreferrer">
              {chip}
            </a>
          </Tooltip>
        ) : (
          <span key={s.exchange}>{chip}</span>
        );
      })}
    </Stack>
  );
};
